import type { ChatUIActionLink } from "@/schema"

import AutomationHandoff from "./action-links/automation-handoff"
import CreateNote from "./action-links/create-note"
import CreateTask from "./action-links/create-task"
import DataActionApproval from "./action-links/data-action-approval"
import DownloadDocument from "./action-links/download-document"
import EmailDraft from "./action-links/email-draft"
import ModifyRecord from "./action-links/modify-record"
import StartProject from "./action-links/start-project"

export function ActionLinkPart({
  link,
  householdId,
  disabled,
}: {
  link: ChatUIActionLink
  householdId?: string
  disabled: boolean
}) {
  switch (link.type) {
    case "email_draft":
      return <EmailDraft id={link.id} householdId={householdId} />
    case "modify_record":
      return <ModifyRecord id={link.id} />
    case "create_task":
      return <CreateTask id={link.id} />
    case "create_note":
      return <CreateNote id={link.id} householdId={householdId} />
    case "start_project":
      return <StartProject id={link.id} />
    case "download_document":
      return <DownloadDocument id={link.id} />
    case "data_action_approval":
      return <DataActionApproval id={link.id} disabled={disabled} />
    case "automation_handoff":
      return <AutomationHandoff id={link.id} />
    default:
      return null
  }
}
